// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal__indicator-icon{height:64px;margin-bottom:24px;margin-left:auto;margin-right:auto;width:64px}.modal__indicator-icon img{height:64px;width:64px}.modal__indicator-value{font-size:24px;font-weight:500;line-height:120%;margin-bottom:16px;text-align:center}.modal__indicator-text{color:#6c7684;font-size:16px;line-height:150%;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
